var path = 'src/app/components/customer/loans/new-loan/list/list-table/customer-loan-create-list-table.template.html';
var html = "<dynamic-list\n  columns=\"$ctrl.columns\"\n  data=\"$ctrl.loanTypes\"\n  sorting=\"$ctrl.sorting\"\n>\n</dynamic-list>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;